import { SET_ADD_MEDICATION } from 'helpers/types';

const INITIAL_STATE = { selectedMedication: {} };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ADD_MEDICATION:
      return { selectedMedication: { name: action.payload } };
    default:
      return state;
  }
}
